import { Typography } from '@euler/app/components/typography';
import {
  CardLoading,
  CardNotice,
} from '@euler/app/flows/ai-suite/components/ChatCard';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiUploadedDatasetView } from '@euler/model/bi/dataset';
import { memo } from 'react';
import { View } from 'react-native';
import { DatasetChoiceRow } from './DatasetChoiceRow';
import { biDatasetFacts } from './functions/biDatasetFacts';
import { useBiUsableDatasets } from './functions/useBiUsableDatasets';

/** **查看全部**: every other dataset the user can use, read when opened. */
export const AllDatasets = memo(
  ({
    exclude,
    disabled,
    onChoose,
  }: {
    /** The datasets the choice already offers. */
    exclude: string[];
    disabled: boolean;
    onChoose: (dataset: BiUploadedDatasetView) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const state = useBiUsableDatasets();
    const datasets =
      state.kind === 'ready'
        ? state.datasets.filter(dataset => !exclude.includes(dataset.id))
        : [];
    return (
      <View style={{ gap: rpx(8) }}>
        <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
          全部数据
        </Typography.Text>
        {state.kind === 'loading' ? (
          <CardLoading label="正在读取你的数据…" />
        ) : state.kind === 'failed' ? (
          <CardNotice tone="danger" text="数据列表没有加载出来。" />
        ) : !datasets.length ? (
          <CardNotice text="没有其他数据了。" />
        ) : null}
        {datasets.map(dataset => (
          <DatasetChoiceRow
            key={dataset.id}
            name={dataset.name}
            facts={biDatasetFacts(dataset)}
            disabled={disabled}
            onPress={() => onChoose(dataset)}
          />
        ))}
      </View>
    );
  },
);
